(() => {
  const hero = document.querySelector("#hero.zl-hero");
  if (!hero) return;

  const video = hero.querySelector(".zl-hero__video");
  if (!video) return;

  console.log("[hero] watchdog activo");

  let lastTime = 0;
  let stalledCount = 0;
  let recovering = false;

  const setFallback = (reason) => {
    if (!hero.classList.contains("is-video-fallback")) {
      hero.classList.add("is-video-fallback");
      console.warn("[hero] fallback:", reason);
    }
  };

  const clearFallback = () => {
    if (hero.classList.contains("is-video-fallback")) {
      hero.classList.remove("is-video-fallback");
      console.log("[hero] fallback OFF (video ok)");
    }
  };

  // Recuperación: recarga el video sin recargar la página
  const recover = async (reason) => {
    if (recovering) return;
    recovering = true;

    console.warn("[hero] recover start:", reason);

    try {
      // pausa
      video.pause();

      // fuerza recarga del recurso (sin perder sources)
      video.load();

      // intenta play
      const p = video.play();
      if (p && typeof p.then === "function") await p;

      // si llegó aquí, está vivo
      stalledCount = 0;
      clearFallback();
      console.log("[hero] recover ok");
    } catch (e) {
      // si falla, nos quedamos con poster (no negro)
      setFallback("recover failed");
      console.error("[hero] recover failed:", e);
    } finally {
      recovering = false;
    }
  };

  // Eventos típicos de “me quedé sin video”
  video.addEventListener("stalled", () => recover("stalled event"));
  video.addEventListener("error",   () => recover("error event"));
  video.addEventListener("abort",   () => recover("abort event"));
  video.addEventListener("waiting", () => {
    stalledCount++;
    console.log("[hero] waiting...", stalledCount);
    if (stalledCount >= 3) recover("waiting x3");
  });

  // Watchdog: si el video deja de avanzar por X segundos → recover
  setInterval(() => {
    // si no está reproduciendo, no molestamos
    if (video.paused || video.ended) return;

    const t = video.currentTime;

    // si no avanzó nada desde la última revisión
    if (t === lastTime) {
      console.warn("[hero] video no avanza, intentando recover...");
      recover("currentTime frozen");
      // mientras tanto, dejamos el fondo visible
      setFallback("video frozen");
    } else {
      lastTime = t;
      clearFallback(); // video volvió a pintar frames
    }
  }, 4000);

  // Cuando vuelves a la pestaña, reintenta (a veces el navegador “duerme” el video)
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible") {
      recover("tab visible again");
    }
  });
})();


(() => {
  const toggle = document.querySelector(".nav-toggle");
  const drawer = document.getElementById("mobile-menu");
  const overlay = document.querySelector("[data-mobile-overlay]");
  const closeBtn = document.querySelector(".mobile-close");

  if (!toggle || !drawer || !overlay || !closeBtn) return;

  const openMenu = () => {
    document.body.classList.add("menu-open");
    toggle.setAttribute("aria-expanded", "true");
    drawer.setAttribute("aria-hidden", "false");
  };

  const closeMenu = () => {
    document.body.classList.remove("menu-open");
    toggle.setAttribute("aria-expanded", "false");
    drawer.setAttribute("aria-hidden", "true");
  };

  toggle.addEventListener("click", openMenu);
  closeBtn.addEventListener("click", closeMenu);
  overlay.addEventListener("click", closeMenu);

  // Cerrar con ESC
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && document.body.classList.contains("menu-open")) {
      closeMenu();
    }
  });

  // Cerrar al dar click en un link
  drawer.querySelectorAll("a[href^='#']").forEach(a => {
    a.addEventListener("click", () => closeMenu());
  });
})();
// App entry (si no usas bundler, concatena en gulp o cambia a vanilla)
(() => {
  const header = document.getElementById('siteHeader');
  if (!header) return;

  const onScroll = () => {
    const y = window.scrollY || 0;
    header.classList.toggle('is-scrolled', y > 20);
    header.classList.toggle('is-transparent', y <= 20);
  };

  onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });
})();

// Sliders
(() => {

  const slider = document.getElementById("solucionesSlider");
  if (!slider) return;

  const track = slider.querySelector(".soluciones-slider__track");
  const items = Array.from(slider.querySelectorAll(".soluciones-slider__item"));
  const cards = document.querySelectorAll(".product-card");

  if (items.length < 2) return;

  let index = 0;
  const delay = 3500;

  const activarCard = (cardId) => {

    cards.forEach(card => {
      card.classList.remove("activo");
    });

    const cardActiva = document.getElementById(cardId);
    if (cardActiva) {
      cardActiva.classList.add("activo");
    }

    console.log("Card activa:", cardId);
  };

  const goTo = (i) => {

    index = (i + items.length) % items.length;

    const x = items[index].offsetLeft;
    track.style.transform = `translateX(-${x}px)`;

    const cardRelacionada = items[index].dataset.card;
    activarCard(cardRelacionada);

    console.log("Slide actual:", index);
  };

  const next = () => goTo(index + 1);

  let timer = setInterval(next, delay);

  slider.addEventListener("mouseenter", () => clearInterval(timer));
  slider.addEventListener("mouseleave", () => timer = setInterval(next, delay));

  goTo(0);

  window.addEventListener("resize", () => goTo(index));

})(); 

(() => {
  const onReady = (fn) => {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn, { once: true });
    } else {
      fn();
    }
  };

  onReady(() => {
    console.log("[metodologia] init");

    const track = document.querySelector("#div_metodologia .div_row_metodologia");
    if (!track) return;

    const cards = Array.from(track.querySelectorAll(".div_row_cell_img"));
    if (!cards.length) return;

    const btnPrev = document.querySelector("#div_metodologia .div_metodologia_nav .prev");
    const btnNext = document.querySelector("#div_metodologia .div_metodologia_nav .next");

    const dotsWrap = document.querySelector("#div_metodologia .div_metodologia_dots");
    const dots = dotsWrap ? Array.from(dotsWrap.querySelectorAll("span")) : [];

    console.log("[metodologia] cards:", cards.length, "btnPrev:", !!btnPrev, "btnNext:", !!btnNext);

    let currentIndex = 0;

    const paintDots = (active) => {
      if (!dots.length) return;
      dots.forEach((d, i) => d.classList.toggle("dot_active", i === active));
    };

    const goToIndex = (i, reason) => {
      const total = cards.length;
      const idx = ((i % total) + total) % total; // loop real
      currentIndex = idx;

      console.log("[metodologia] goToIndex", idx, reason || "");

      cards[idx].scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "center",
      });

      paintDots(idx);
    };

    // Detecta la tarjeta más visible (para actualizar currentIndex cuando el usuario arrastra)
    const getIndexByCenter = () => {
      const rTrack = track.getBoundingClientRect();
      const centerX = rTrack.left + rTrack.width / 2;

      let best = 0;
      let bestDist = Infinity;

      for (let i = 0; i < cards.length; i++) {
        const r = cards[i].getBoundingClientRect();
        const cCenter = r.left + r.width / 2;
        const dist = Math.abs(cCenter - centerX);
        if (dist < bestDist) {
          bestDist = dist;
          best = i;
        }
      }
      return best;
    };

    // Init
    currentIndex = getIndexByCenter();
    paintDots(currentIndex);

    // NEXT/PREV con loop garantizado
    if (btnNext) {
      btnNext.addEventListener("click", () => {
        console.log("[metodologia] NEXT click current:", currentIndex);
        goToIndex(currentIndex + 1, "next");
      });
    }

    if (btnPrev) {
      btnPrev.addEventListener("click", () => {
        console.log("[metodologia] PREV click current:", currentIndex);
        goToIndex(currentIndex - 1, "prev");
      });
    }

    // Scroll manual: mantener currentIndex sincronizado
    let t = null;
    track.addEventListener("scroll", () => {
      clearTimeout(t);
      t = setTimeout(() => {
        const idx = getIndexByCenter();
        if (idx !== currentIndex) {
          currentIndex = idx;
          console.log("[metodologia] scroll -> currentIndex:", currentIndex);
          paintDots(currentIndex);
        }
      }, 80);
    });

    // Test en consola
    window.__metodologiaGoTo = goToIndex;
    console.log("[metodologia] OK. Test: __metodologiaGoTo(0..6)");
  });
})();